<template>
  <nav class="client-navbar navbar navbar-expand-lg sticky-top">
    <div class="container-fluid px-4">
      <!-- Brand -->
      <router-link :to="{ name: 'ClientDashboard' }" class="navbar-brand">
        <img src="@/assets/img/logo.png" alt="PREFERE PLUS" height="44" />
        <div class="brand-text d-none d-md-block">
          <span class="brand-title">Espace Client</span>
          <small class="brand-subtitle">PREFERE PLUS</small>
        </div>
      </router-link>

      <!-- Toggler -->
      <button
        class="navbar-toggler"
        type="button"
        @click="menuOpen = !menuOpen"
        aria-label="Menu"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Links -->
      <div class="collapse navbar-collapse" :class="{ show: menuOpen }">
        <ul class="navbar-nav ms-auto align-items-lg-center">
          <li class="nav-item">
            <router-link
              :to="{ name: 'ClientDashboard' }"
              class="nav-link"
              active-class="active"
              @click="menuOpen = false"
            >
              <i class="fas fa-tachometer-alt me-1"></i> Tableau de bord
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'ClientOffers' }"
              class="nav-link"
              active-class="active"
              @click="menuOpen = false"
            >
              <i class="fas fa-briefcase me-1"></i> Mes offres
            </router-link>
          </li>

          <!-- User dropdown -->
          <li class="nav-item dropdown user-dropdown">
            <a
              class="nav-link dropdown-toggle d-flex align-items-center"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div class="client-avatar">
                <img v-if="clientLogo" :src="logoUrl" :alt="clientName" />
                <span v-else>{{ clientInitials }}</span>
              </div>
              <div class="user-info d-none d-lg-block ms-2">
                <div class="user-name">{{ firstName }} {{ lastName }}</div>
                <small class="user-company">{{ clientName }}</small>
              </div>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li class="dropdown-header">
                <div class="fw-bold">{{ firstName }} {{ lastName }}</div>
                <small class="text-muted">{{ clientName }}</small>
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <a class="dropdown-item text-danger" href="#" @click.prevent="logout">
                  <i class="fas fa-sign-out-alt me-2"></i> Se déconnecter
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import clientApi from '@/services/clientApi'

export default {
  name: 'TheClientNavbar',
  inject: ['ToastSuccess', 'ToastError'],
  data() {
    return {
      menuOpen: false,
      firstName: localStorage.getItem('firstName') || '',
      lastName: localStorage.getItem('lastName') || '',
      clientName: localStorage.getItem('client_name') || '',
      clientLogo: localStorage.getItem('client_logo') || '',
    }
  },
  computed: {
    clientInitials() {
      const name = this.clientName || ''
      const parts = name.trim().split(/\s+/)
      const first = parts[0] ? parts[0].charAt(0) : ''
      const second = parts[1] ? parts[1].charAt(0) : ''
      return (first + second).toUpperCase() || 'CL'
    },
    logoUrl() {
      if (!this.clientLogo) return ''
      if (this.clientLogo.startsWith('http')) return this.clientLogo
      return process.env.VUE_APP_API_ENDPOINT + '/storage/' + this.clientLogo
    },
  },
  methods: {
    async logout() {
      try {
        await clientApi.post('/client/logout')
      } catch (e) {
        // ignore
      }
      localStorage.clear()
      this.$router.push({ name: 'Login' })
    },
  },
}
</script>

<style scoped>
.client-navbar {
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(37, 150, 190, 0.08);
  padding: 0.6rem 0;
  border-bottom: 3px solid #2596be;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-title {
  font-weight: 700;
  color: #2596be;
  font-size: 1.05rem;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #6c757d;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.nav-link {
  color: #2c3e50 !important;
  font-weight: 500;
  padding: 0.5rem 1rem !important;
  border-radius: 8px;
  transition: all 0.2s;
}

.nav-link:hover {
  background: rgba(37, 150, 190, 0.08);
  color: #2596be !important;
}

.nav-link.active {
  background: linear-gradient(135deg, #2596be, #29b3cd);
  color: #fff !important;
}

.client-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e95d16, #bc6a3c);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  overflow: hidden;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.client-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  line-height: 1.2;
}

.user-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #2c3e50;
}

.user-company {
  color: #6c757d;
  font-size: 0.75rem;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 0.5rem;
  min-width: 220px;
}

.dropdown-item {
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
}

.dropdown-header {
  padding: 0.75rem 1rem;
}

@media (max-width: 991px) {
  .navbar-collapse {
    padding-top: 1rem;
  }
}
</style>
